import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {HttpInterceptorService, RESTService} from '@covalent/http-deprec';

import {GezeichneteProdukte, MaklerPaket} from './Model/MaklerPaket';
import {environment} from '../../../../environments/environment';

@Injectable()
export class PaketService extends RESTService<MaklerPaket>{


  constructor(
    public http:HttpInterceptorService
  ) {
    super (http, {
      baseUrl: `${environment.apiHost}`,
      path: 'makpak/findMaklerPakete'
    });
  }

  // getPackages(user: string, vtnr: string): Observable<MaklerPaket[]> {
  //   let urlParam = `${user +  "/" + vtnr}`;
  //   console.log("Url param maklerPaketStatusInput: "+urlParam);
  //   return super.get(urlParam).map((res:MaklerPaket[]) => {
  //     return res;
  //   });
  // }

  getPackages(): Observable<MaklerPaket[]> {
    let packages = [
      new MaklerPaket("1", "eins", "test", "test", "test","","", []),
      ];
    return of(packages);
  }
}
